import { FC } from 'react';

import { getSemanticColorVariable } from '../../theme/colors';
import { TextProps } from '../Text';
import Heading2 from '../Text/Heading2';

interface Props {
  noBorderBottom?: boolean;
}

const DialogTitle: FC<Props & TextProps> = ({
  noBorderBottom,
  ...props
}) => (
  <Heading2
    borderBottom={noBorderBottom ? undefined : `1px solid ${getSemanticColorVariable('divider')}`}
    className="dialog_dialog-title"
    fontSize={20}
    fontWeight="bold"
    marginBottom={noBorderBottom ? 4 : 6}
    paddingBottom={noBorderBottom ? undefined : 4}
    {...props}
  />
);

export default DialogTitle;
